import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TableColumn, ButtonComponent, ButtonSizeType } from '@ui/aos-lib';
import { Observable } from 'rxjs';

import { UserRole, UserRolesPageContext, UserRolesModelContext } from '../../user-roles.types';

@Component({
  template: `
    <div class="flex">
      @let permissions = getActionsPermission() | async;
      @if (permissions?.[0]) {
        <ui-button
          (click)="userRoleEdit()"
          [iconName]="'pencil'"
          [size]="editButtonSize"
        ></ui-button>
      }
      @if (permissions?.[1]) {
        <ui-button
          (click)="userRoleDelete()"
          [iconName]="'delete'"
          [disabled]="!isRestricted(item.externalRoleName)"
          [size]="editButtonSize"
        ></ui-button>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, AsyncPipe]
})
export class ActionsColumnComponent {
  private readonly userRolesPageComponent = inject(UserRolesPageContext, { optional: true });
  private readonly userRolesModel = inject(UserRolesModelContext);

  @Input() item!: UserRole;
  @Input() column!: TableColumn;
  protected readonly editButtonSize: ButtonSizeType = 'small';
  protected readonly deleteRestrictionRoles = ['admin'];

  protected userRoleEdit(): void {
    this.userRolesPageComponent!.selectedEditItem = this.item;
    this.userRolesPageComponent!.openModal();
  }

  protected userRoleDelete(): void {
    if (this.isRestricted(this.item.externalRoleName)) {
      this.userRolesPageComponent!.userRoleDelete(this.item.id);
    }
  }

  getActionsPermission(): Observable<[boolean, boolean]> {
    return this.userRolesModel.permissionGroup$;
  }

  isRestricted(externalRoleName: string): boolean {
    return !this.deleteRestrictionRoles.find(item => item === externalRoleName);
  }
}
